import script from "./grupoForm.vue?vue&type=script&setup=true&lang=js"
export * from "./grupoForm.vue?vue&type=script&setup=true&lang=js"

import "./grupoForm.vue?vue&type=style&index=0&id=7a99cc7e&scoped=true&lang=css"
import "./grupoForm.vue?vue&type=style&index=1&id=7a99cc7e&lang=css"
import "./grupoForm.vue?vue&type=style&index=2&id=7a99cc7e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a99cc7e"]])

export default __exports__